module.exports = __webpack_public_path__ + "static/img/nejLogo.8e733e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nejLogo.svg
// module id = kL22
// module chunks = 3